import { createRequestType } from '../../helpers/requestType';

export const getDashboardStatisticActionType = createRequestType('GET_DASHBOARD_STATISTIC');
interface getDashboardStatisticRequestAction {
  type: typeof getDashboardStatisticActionType.request;
  payload: any;
}

interface getDashboardStatisticSuccessAction {
  type: typeof getDashboardStatisticActionType.success;
  payload: any;
}

interface getDashboardStatisticFailureAction {
  type: typeof getDashboardStatisticActionType.failure;
  payload: any;
}

export const getLiveStatisticActionType = createRequestType('GET_LIVE_STATISTIC');
interface getLiveStatisticRequestAction {
  type: typeof getLiveStatisticActionType.request;
  payload: any;
}

interface getLiveStatisticSuccessAction {
  type: typeof getLiveStatisticActionType.success;
  payload: any;
}

interface getLiveStatisticFailureAction {
  type: typeof getLiveStatisticActionType.failure;
  payload: any;
}

export type StatisticActionTypes = getDashboardStatisticRequestAction | getDashboardStatisticSuccessAction| getDashboardStatisticFailureAction | getLiveStatisticRequestAction | getLiveStatisticSuccessAction | getLiveStatisticFailureAction
